import type { ReactNode } from 'react';
import Typography from '@classify/react-core-components/Typography';
import tinycolor2 from 'tinycolor2';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';

const Wrapper = styled('div')(({ theme: { spacing, radius } }) => ({
  padding: spacing(2),
  margin: spacing(1),
  maxWidth: 1280,
  borderRadius: radius.banner,
}));

export interface PartTitleProps {
  number: number;
  color: string;
  children: ReactNode;
  component?: any;
  id: string;
}

const PartTitle = ({ number, color, children, component = 'h3', id }: PartTitleProps) => (
  <Wrapper
    id={`part-${id}`}
    sx={{ color, backgroundColor: tinycolor2(color).setAlpha(0.08).toString() }}
  >
    <ContentWrapper>
      <Typography
        sx={{ lineHeight: 1 }}
        color={tinycolor2(color).darken(2).toString()}
        variant="overline"
        component="div"
      >
        {translate('course_toc.part', { part_number: number })}
      </Typography>
      <Typography color="textPrimary" variant="h6" component={component}>
        {children}
      </Typography>
    </ContentWrapper>
  </Wrapper>
);

export default PartTitle;
